import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylish%20editorial%20scene%20of%20folded%20streetwear%20garments%20and%20a%20pair%20of%20sneakers%20arranged%20on%20a%20warm%20terracotta%20and%20cream%20backdrop%20with%20soft%20dramatic%20natural%20light%20varied%20fabric%20textures%20premium%20fashion%20product%20photography%20rich%20warm%20tones&width=1600&height=900&seq=hero-allchinabuy-2026&orientation=landscape"
          alt="AllChinaBuy Spreadsheet curated streetwear product finds"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 text-foreground-800 text-xs md:text-sm font-medium backdrop-blur mb-5">
          <i className="ri-sparkling-line text-primary-500"></i>
          {t('home.hero.badge')}
        </span>

        <h1 className="font-heading text-3xl md:text-5xl font-semibold text-background-50 leading-tight max-w-3xl mx-auto">
          {t('home.hero.title')}
        </h1>

        <p className="mt-5 text-background-50/90 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          {t('home.hero.subtitle')}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#categories"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            {t('home.hero.ctaPrimary')}
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#featured"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-50/90 text-foreground-900 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-background-100 transition-colors"
          >
            {t('home.hero.ctaSecondary')}
          </a>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-foreground-800 transition-colors"
          >
            <i className="ri-external-link-line"></i>
            {t('home.hero.mainCta1')}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-accent-600 transition-colors"
          >
            <i className="ri-shopping-bag-3-line"></i>
            {t('home.hero.mainCta2')}
          </a>
        </div>
      </div>
    </section>
  );
}